import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, defineComponent as l, mergeModels as u, mergeProps as d, normalizeClass as f, openBlock as p, ref as m, renderList as h, renderSlot as g, toDisplayString as _, unref as v, useAttrs as y, useModel as b, withCtx as x } from "vue";
import { FieldGroup as S, SearchSuggestTextInputField as C, SelectAutocompleteField as w, TextInputField as T, utils as E } from "@myparcel-frontend/forms";
import { Alpha2CountryCode as D, isPostalCodeOptional as ee, isValidPostalCode as O, useAddressService as k } from "@myparcel-frontend/address-service";
import { useProposition as te } from "@myparcel-frontend/proposition";
import { Country as A, Region as j } from "@myparcel-frontend/types";
import { ExternalLinkAnchor as ne, FormRow as re, Label as M, Notification as ie, PopOver as N, SearchSuggestTextInput as ae, Target as oe } from "@myparcel-frontend/ui";
import { useFieldValue as P, useFormValues as F, useSetFormValues as I } from "vee-validate";
import { Translation as se, useI18n as ce } from "vue-i18n";
import { cn as L, object as R, regex as z, string as B } from "@myparcel-frontend/utils";
import { isEqual as V } from "es-toolkit";
import { zAddress as H, zContactBusiness as le, zContactPrivate as ue } from "@myparcel-frontend/order-service";
import U, { object as de } from "zod";
//#endregion
//#region src/components/form/fields/BusinessContactField/BusinessContactField.vue
var fe = /* @__PURE__ */ l({
	__name: "BusinessContactField",
	props: {
		name: {},
		label: {},
		addresses: { default: () => [] },
		placeholder: {},
		disabled: {
			type: Boolean,
			default: !1
		},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		maxLength: { default: void 0 },
		buttonVariant: { default: "secondary" },
		cancelLabel: { default: void 0 },
		loading: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["selected", "search"],
	setup(e, { emit: r }) {
		let i = e, a = r, o = (e) => {
			if (!e) return;
			let t = {
				company: `${e}*`,
				page: 1,
				size: 5
			};
			a("search", t);
		}, s = (e) => {
			let t = i.addresses.find((t) => t.id === Number(e.value));
			a("selected", t);
		}, c = (e) => {
			let t = e.cc;
			return [
				[
					e.street,
					e.number,
					e.number_suffix,
					e.box_number
				].filter(Boolean).join(" "),
				e.city,
				t
			].filter(Boolean).join(", ");
		}, l = t(() => i.addresses.map((e) => ({
			label: e.company,
			sublabel: c(e),
			value: String(e.id)
		})));
		return (e, t) => (p(), n(v(C), d(e.$props, {
			suggestions: l.value,
			onSearch: o,
			onSelected: s
		}), null, 16, ["suggestions"]));
	}
}), pe = /* @__PURE__ */ l({
	__name: "PrivateContactField",
	props: {
		name: {},
		label: {},
		addresses: { default: () => [] },
		placeholder: {},
		disabled: {
			type: Boolean,
			default: !1
		},
		hideLabel: {
			type: Boolean,
			default: !1
		},
		sublabel: { default: void 0 },
		note: { default: void 0 },
		maxLength: { default: void 0 },
		buttonVariant: { default: "secondary" },
		cancelLabel: { default: void 0 },
		loading: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["selected", "search"],
	setup(e, { emit: r }) {
		let i = e, a = r, o = (e) => {
			if (!e) return;
			let t = {
				query: `${e}*`,
				page: 1,
				size: 5
			};
			a("search", t);
		}, s = (e) => {
			let t = i.addresses.find((t) => t.id === Number(e.value));
			a("selected", t);
		}, c = (e) => {
			let t = e.cc;
			return [
				[
					e.street,
					e.number,
					e.number_suffix,
					e.box_number
				].filter(Boolean).join(" "),
				e.city,
				t
			].filter(Boolean).join(", ");
		}, l = t(() => i.addresses.map((e) => ({
			label: e.person,
			sublabel: c(e),
			value: String(e.id)
		})));
		return (e, t) => (p(), n(v(C), d(e.$props, {
			suggestions: l.value,
			onSearch: o,
			onSelected: s
		}), null, 16, ["suggestions"]));
	}
});
//#endregion
//#region src/composables/useValidate.ts
function W(e) {
	let { validate: t } = k(), n = F(), r = m(!0);
	return {
		addressValid: r,
		validateAddress: async (i) => {
			let a = e ? `${e}.address` : "address", { countryCode: o, postalCode: s, houseNumber: c, houseNumberSuffix: l, city: u, region: d, street: f } = R.get(n.value, a);
			if (!o || !s || !c) return;
			let p = {
				countryCode: o,
				postalCode: s,
				houseNumber: c,
				...l && { houseNumberSuffix: l },
				...u && { city: u },
				...d && { region: d },
				...f && { street: f },
				...i && { validationType: i }
			};
			try {
				let { valid: e } = await t(p);
				return r.value = e, e;
			} catch {
				r.value = !1;
			}
		}
	};
}
//#endregion
//#region src/composables/useAddress.ts
var G = m([]);
function K() {
	let { getAddresses: e } = k(), { addressValid: t } = W(), n = I();
	return {
		addresses: G,
		fetchAddresses: async (n) => {
			if (!(n.countryCode === "NL" && n.postalCode && n.houseNumber)) {
				t.value = !1, G.value = [];
				return;
			}
			let r = {
				countryCode: "NL",
				postalCode: n.postalCode,
				houseNumber: n.houseNumber,
				...n.houseNumberSuffix ? { houseNumberSuffix: n.houseNumberSuffix } : {},
				limit: n.limit ?? 5
			};
			try {
				let { results: n } = await e(r);
				if (!n?.length) {
					t.value = !1;
					return;
				}
				return G.value = n, t.value = !0, n;
			} catch {
				G.value = [];
			}
		},
		setAddressFormValues: (e, t) => {
			if (!t) {
				n({ address: e }, !1);
				return;
			}
			let r = t.split(".").filter(Boolean).reduceRight((e, t) => ({ [t]: e }), { address: e });
			n(r, !1);
		}
	};
}
//#endregion
//#region src/composables/useAutofill.ts
function me() {
	let { addresses: e, setAddressFormValues: n, fetchAddresses: r } = K();
	return {
		autofillStreetAndCity: async (e, t) => {
			let i = await r({
				...e,
				countryCode: D.NL
			});
			i?.length && n({
				street: i[0].street,
				...i.length > 1 || i[0].countryCode === D.BE ? {} : { houseNumberSuffix: i[0].houseNumberSuffix },
				city: i[0].city
			}, t);
		},
		houseNumberSuffixSuggestions: t(() => e.value.filter((e) => e.countryCode !== D.BE).filter((e) => e.houseNumberSuffix).map((e) => ({
			label: e.houseNumberSuffix,
			value: e.houseNumberSuffix
		})))
	};
}
//#endregion
//#region src/composables/useContact.ts
function he() {
	let e = I();
	return { setContactFormValues: (t, n) => {
		if (!n) {
			e({ contact: t }, !1);
			return;
		}
		let r = n.split(".").filter(Boolean).reduceRight((e, t) => ({ [t]: e }), { contact: t });
		e(r, !1);
	} };
}
//#endregion
//#region src/utils/fieldName.ts
var q = (e, t) => t ? t.endsWith(".") ? `${t}${e}` : `${t}.${e}` : e, ge = (e) => e === A.Netherlands, _e = (e) => e === A.Belgium, ve = {
	Normal: "0 0 16 16",
	Medium: "0 0 24 24",
	MediumLarge: "0 0 32 32",
	Large: "0 0 48 48",
	Social: "0 0 50 50",
	XLarge: "0 0 88 88",
	XXLarge: "0 0 200 200"
}, J = {
	Normal: 16,
	Medium: 24,
	MediumLarge: 32,
	Large: 48,
	Social: 50,
	XLarge: 88,
	XXLarge: 200
}, ye = [
	"aria-label",
	"height",
	"role",
	"viewBox",
	"width"
], Y = /* @__PURE__ */ l({
	__name: "IconBase",
	props: {
		width: { default: void 0 },
		height: { default: void 0 },
		viewbox: { default: void 0 },
		size: { default: J.Normal },
		ariaLabel: { default: void 0 }
	},
	setup(e) {
		let n = y(), r = e, a = Object.entries(J).find(([, e]) => e === r.size)[0], o = t(() => String(r.height ?? J[a])), s = t(() => String(r.width ?? J[a])), c = t(() => String(r.viewbox ?? ve[a])), l = t(() => r.ariaLabel ? "img" : "presentation");
		return (t, r) => (p(), i("svg", {
			"aria-label": e.ariaLabel,
			class: f(v(L)("align-baseline inline-block overflow-visible", v(n).class)),
			height: o.value,
			role: l.value,
			viewBox: c.value,
			width: s.value,
			xmlns: "http://www.w3.org/2000/svg"
		}, [g(t.$slots, "default")], 10, ye));
	}
}), X = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, be = {}, xe = {
	d: "m6 3 5 5-5 5",
	fill: "none",
	stroke: "currentColor"
};
function Z(e, t) {
	return p(), i("path", xe);
}
var Se = /*#__PURE__*/ X(be, [["render", Z]]), Q = {}, Ce = {
	"clip-rule": "evenodd",
	d: "M3.99992 5.99999C3.99992 3.79085 5.79078 1.99999 7.99992 1.99999C10.2091 1.99999 11.9999 3.79085 11.9999 5.99999C11.9999 6.52092 11.7573 7.28413 11.3527 8.17373C10.9542 9.05026 10.42 10.0045 9.88165 10.8911C9.34405 11.7766 8.80585 12.5887 8.40185 13.1797C8.24478 13.4094 8.10819 13.6055 7.99992 13.7593C7.89165 13.6055 7.75505 13.4094 7.59799 13.1797C7.19399 12.5887 6.65582 11.7766 6.11818 10.8911C5.57985 10.0045 5.04566 9.05026 4.64711 8.17373C4.2426 7.28413 3.99992 6.52092 3.99992 5.99999ZM7.73052 14.5297C7.73052 14.5297 7.73065 14.5298 7.99992 14.3333L7.73052 14.5297C7.79325 14.6157 7.89345 14.6667 7.99992 14.6667C8.10639 14.6667 8.20645 14.6158 8.26919 14.5298L7.99992 14.3333C8.26918 14.5298 8.26919 14.5298 8.26919 14.5298L8.27012 14.5285L8.27265 14.5251L8.28225 14.5119L8.31912 14.4608C8.35132 14.4161 8.39832 14.3505 8.45805 14.2662C8.57745 14.0978 8.74785 13.8548 8.95218 13.5559C9.36065 12.9584 9.90578 12.1359 10.4515 11.2371C10.9965 10.3395 11.5457 9.36006 11.9596 8.44973C12.3676 7.55246 12.6666 6.67566 12.6666 5.99999C12.6666 3.42267 10.5773 1.33333 7.99992 1.33333C5.42259 1.33333 3.33325 3.42267 3.33325 5.99999C3.33325 6.67566 3.63224 7.55246 4.04023 8.44973C4.45418 9.36006 5.00332 10.3395 5.54833 11.2371C6.09402 12.1359 6.63919 12.9584 7.04765 13.5559C7.25199 13.8548 7.42239 14.0978 7.54179 14.2662C7.60152 14.3505 7.64852 14.4161 7.68072 14.4608L7.71758 14.5119L7.72719 14.5251L7.72972 14.5285L7.73052 14.5297ZM6.66659 5.99999C6.66659 5.26361 7.26352 4.66666 7.99992 4.66666C8.73632 4.66666 9.33325 5.26361 9.33325 5.99999C9.33325 6.73639 8.73632 7.33333 7.99992 7.33333C7.26352 7.33333 6.66659 6.73639 6.66659 5.99999ZM7.99992 3.99999C6.89532 3.99999 5.99992 4.89543 5.99992 5.99999C5.99992 7.10459 6.89532 7.99999 7.99992 7.99999C9.10452 7.99999 9.99992 7.10459 9.99992 5.99999C9.99992 4.89543 9.10452 3.99999 7.99992 3.99999Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function we(e, t) {
	return p(), i("path", Ce);
}
var Te = /*#__PURE__*/ X(Q, [["render", we]]), Ee = { class: "flex items-center justify-between" }, De = { key: 0 }, Oe = { key: 1 }, ke = /* @__PURE__ */ l({
	__name: "AddressFinderSuggestionTextInput",
	props: /*@__PURE__*/ u({
		countryCode: {},
		name: {},
		labelledBy: {},
		maxSuggestions: { default: 5 },
		placeholder: { default: "" }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ u(["selected"], ["update:modelValue"]),
	setup(r, { emit: o }) {
		let { getAddresses: s } = k(), l = b(r, "modelValue"), u = o, d = r, f = m([]), g = m(!1), y = (e) => {
			(!e || e.length === 0) && (f.value = []);
		}, S = m(), C = (e) => {
			let t = e.data;
			V(t, S.value) || (S.value = t, u("selected", t));
		}, w = async (e) => {
			if (!e || e.length < 3) {
				f.value = [];
				return;
			}
			let t = {
				query: l.value,
				countryCode: d.countryCode,
				limit: d.maxSuggestions
			};
			g.value = !0;
			let { results: n } = await s(t).finally(() => {
				g.value = !1;
			});
			f.value = n;
		}, T = (e) => {
			let t = e.countryCode === D.BE ? e.boxNumber : e.houseNumberSuffix, n = [
				e.street,
				e.houseNumber,
				t
			].filter(Boolean).join(" ");
			return [
				e.postalCode,
				e.city,
				n
			].filter(Boolean).join(", ");
		}, E = t(() => f.value.map((e) => ({
			label: T(e),
			value: T(e),
			data: e
		})));
		return (t, o) => (p(), n(v(ae), {
			modelValue: l.value,
			"onUpdate:modelValue": o[0] ||= (e) => l.value = e,
			"debounce-time": 300,
			"labelled-by": r.labelledBy,
			loading: g.value,
			"max-length": 200,
			name: r.name,
			placeholder: r.placeholder,
			suggestions: E.value,
			"with-button": !1,
			onBlur: y,
			onSearch: w,
			onSelected: C
		}, {
			listitem: x(({ suggestion: t }) => [a("div", Ee, [a("span", null, [(p(!0), i(e, null, h(v(B).highlightSegments(t.label, l.value), (t) => (p(), i(e, { key: t.text }, [t.isHighlighted ? (p(), i("strong", De, _(t.text), 1)) : (p(), i("span", Oe, _(t.text), 1))], 64))), 128))]), c(v(Y), { size: v(J).Normal }, {
				default: x(() => [t.data?.houseNumber ? (p(), n(v(Te), { key: 0 })) : (p(), n(v(Se), { key: 1 }))]),
				_: 2
			}, 1032, ["size"])])]),
			_: 1
		}, 8, [
			"modelValue",
			"labelled-by",
			"loading",
			"name",
			"placeholder",
			"suggestions"
		]));
	}
}), Ae = { class: "text-gray-500" }, je = /* @__PURE__ */ l({
	__name: "AddressFinderField",
	props: /*@__PURE__*/ u({
		name: {},
		label: {},
		countryCode: {},
		sublabel: {},
		note: {},
		placeholder: {}
	}, {
		modelValue: { default: "" },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ u(["selected"], ["update:modelValue"]),
	setup(e, { emit: t }) {
		let r = t, i = b(e, "modelValue");
		return (t, l) => (p(), n(v(re), null, o({
			label: x(() => [c(v(M), { id: e.name }, {
				sublabel: x(() => [a("span", Ae, _(e.sublabel), 1)]),
				default: x(() => [s(_(e.label) + " ", 1)]),
				_: 1
			}, 8, ["id"])]),
			default: x(() => [c(ke, {
				modelValue: i.value,
				"onUpdate:modelValue": l[0] ||= (e) => i.value = e,
				"country-code": e.countryCode,
				"labelled-by": e.name,
				name: e.name,
				placeholder: e.placeholder,
				onSelected: l[1] ||= (e) => r("selected", e)
			}, null, 8, [
				"modelValue",
				"country-code",
				"labelled-by",
				"name",
				"placeholder"
			])]),
			_: 2
		}, [e.note ? {
			name: "note",
			fn: x(() => [c(v(N), null, {
				default: x(() => [s(_(e.note), 1)]),
				_: 1
			})]),
			key: "0"
		} : void 0]), 1024));
	}
}), Me = { class: "gap-4 flex flex-col" }, Ne = /* @__PURE__ */ l({
	__name: "ShippingAddress",
	props: {
		parentPath: { default: "" },
		countryOptions: {},
		countriesWithAddressFinder: { default: () => [] },
		addressBookSuggestions: { default: () => ({
			business: [],
			private: []
		}) },
		addressBookLoading: {
			type: Boolean,
			default: !1
		},
		isBusinessContactRequired: {
			type: Boolean,
			default: !1
		},
		isStateRequired: {
			type: Boolean,
			default: !1
		},
		disableCountry: { type: Boolean },
		disableContactTypeSwitching: {
			type: Boolean,
			default: !1
		},
		splitName: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["address-book-search", "address-book-selected"],
	setup(l, { emit: u }) {
		let d = l, f = u, { t: m, locale: h } = ce(), { doesCountryHaveStates: g, getStatesForCountry: y } = k(), { autofillStreetAndCity: b, houseNumberSuffixSuggestions: E } = me(), { validateAddress: O, addressValid: j } = W(d.parentPath), { setAddressFormValues: M } = K(), { proposition: N } = te(), { setContactFormValues: ae } = he(), F = t(() => q("address.countryCode", d.parentPath)), I = t(() => q("address.postalCode", d.parentPath)), L = t(() => q("address.houseNumber", d.parentPath)), R = t(() => q("contact.company", d.parentPath)), z = P(F), B = P(I), V = P(L), H = P(R), le = t(() => q("contact.type", d.parentPath)), ue = P(le), U = t(() => d.disableContactTypeSwitching || d.splitName ? q("contact.name", d.parentPath) : q(ue.value === "BUSINESS" ? "contact.attention" : "contact.name", d.parentPath)), de = P(U), G = t(() => d.isBusinessContactRequired ? "" : d.disableContactTypeSwitching || d.splitName ? m("optional") : m("optionalAndAffectsPrice")), ve = t(() => y(z.value).map((e) => ({
			label: m(`location.states.${z.value}.${e}`),
			value: e
		}))), J = t(() => z.value && g(z.value)), ye = t(() => d.isStateRequired ? "" : m("optional")), Y = t(() => ge(z.value)), X = t(() => _e(z.value)), be = t(() => z.value && d.countriesWithAddressFinder.includes(z.value)), xe = t(() => N.value.useToponymicAddressLabels ? "location.toponymy.destinationAddress" : "location.address.street"), Z = async () => {
			await b({
				postalCode: B.value,
				houseNumber: V.value
			}, d.parentPath), await O();
		}, Se = async (e) => {
			M({
				street: e.street,
				houseNumber: e.houseNumber,
				...e.countryCode === D.BE ? {
					boxNumber: e.boxNumber,
					houseNumberSuffix: void 0
				} : {
					boxNumber: void 0,
					houseNumberSuffix: e.houseNumberSuffix
				},
				postalCode: e.postalCode,
				city: e.city,
				...e.municipality ? { region: e.municipality } : {}
			}, d.parentPath), await O();
		}, Q = (e) => {
			f("address-book-selected", e);
		}, Ce = () => {
			if (d.disableContactTypeSwitching || d.splitName) return;
			let e = H.value && H.value.length > 0, t = de.value;
			ae(e ? {
				type: "BUSINESS",
				...t ? { attention: t } : {}
			} : {
				type: "PRIVATE",
				...t ? { name: t } : {}
			}, d.parentPath);
		};
		return (t, u) => (p(), i("div", Me, [
			c(v(w), {
				disabled: l.disableCountry,
				label: v(m)("location.address.country"),
				name: F.value,
				options: l.countryOptions,
				placeholder: v(m)("location.address.country")
			}, null, 8, [
				"disabled",
				"label",
				"name",
				"options",
				"placeholder"
			]),
			J.value ? (p(), n(v(w), {
				key: 0,
				label: v(z) === v(A).Canada ? v(m)("location.address.province") : v(m)("location.address.state"),
				name: v(q)("address.state", l.parentPath),
				options: ve.value,
				placeholder: v(z) === v(A).Canada ? v(m)("location.address.province") : v(m)("location.address.state"),
				sublabel: ye.value
			}, null, 8, [
				"label",
				"name",
				"options",
				"placeholder",
				"sublabel"
			])) : r("", !0),
			c(fe, {
				addresses: l.addressBookSuggestions.business,
				label: v(m)("companyName"),
				loading: l.addressBookLoading,
				name: R.value,
				placeholder: v(m)("companyName"),
				sublabel: G.value,
				onBlur: Ce,
				onSearch: u[0] ||= (e) => f("address-book-search", e),
				onSelected: Q
			}, null, 8, [
				"addresses",
				"label",
				"loading",
				"name",
				"placeholder",
				"sublabel"
			]),
			l.splitName ? (p(), i(e, { key: 2 }, [c(v(T), {
				label: v(m)("firstName"),
				name: v(q)("contact.firstName", l.parentPath),
				placeholder: v(m)("firstName")
			}, null, 8, [
				"label",
				"name",
				"placeholder"
			]), c(v(T), {
				label: v(m)("lastName"),
				name: v(q)("contact.lastName", l.parentPath),
				placeholder: v(m)("lastName")
			}, null, 8, [
				"label",
				"name",
				"placeholder"
			])], 64)) : (p(), n(pe, {
				key: 1,
				addresses: l.addressBookSuggestions.private,
				label: v(m)("name"),
				loading: l.addressBookLoading,
				name: U.value,
				placeholder: v(m)("name"),
				onSearch: u[1] ||= (e) => f("address-book-search", e),
				onSelected: Q
			}, null, 8, [
				"addresses",
				"label",
				"loading",
				"name",
				"placeholder"
			])),
			be.value ? (p(), n(je, {
				key: 3,
				"country-code": v(z),
				label: v(m)("location.fields.addressFinder.label"),
				name: v(q)("addressFinder"),
				note: v(m)("location.fields.addressFinder.note"),
				placeholder: v(m)("location.fields.addressFinder.placeholder"),
				sublabel: v(m)("optional"),
				onSelected: u[2] ||= (e) => Se(e)
			}, null, 8, [
				"country-code",
				"label",
				"name",
				"note",
				"placeholder",
				"sublabel"
			])) : r("", !0),
			Y.value ? (p(), i(e, { key: 4 }, [
				v(B) && v(V) && !v(j) ? (p(), n(v(re), { key: 0 }, {
					default: x(() => [c(v(ie), {
						id: "address-not-found",
						variant: "warning"
					}, {
						default: x(() => [a("p", null, _(v(m)("location.address.notification.addressNotFound")), 1)]),
						_: 1
					})]),
					_: 1
				})) : r("", !0),
				c(v(S), { label: v(m)("location.fields.postalCodeAndNumber.label") }, o({
					default: x(() => [
						c(v(T), {
							class: "basis-2/4",
							"hide-label": "",
							label: v(m)("location.address.postalCode"),
							name: I.value,
							placeholder: v(m)("location.address.postalCode"),
							"preserve-label-gap": !1,
							onBlur: Z
						}, null, 8, [
							"label",
							"name",
							"placeholder"
						]),
						c(v(T), {
							class: "basis-1/4",
							"hide-label": "",
							label: v(m)("location.address.houseNumber"),
							name: L.value,
							placeholder: v(m)("location.address.houseNumber"),
							"preserve-label-gap": !1,
							onBlur: Z
						}, null, 8, [
							"label",
							"name",
							"placeholder"
						]),
						c(v(C), {
							class: "basis-1/4",
							"hide-label": "",
							label: v(m)("location.address.houseNumberExtension"),
							name: v(q)("address.houseNumberSuffix", l.parentPath),
							placeholder: v(m)("location.address.houseNumberExtension"),
							"preserve-label-gap": !1,
							suggestions: v(E),
							onBlur: u[3] ||= async () => await v(O)(),
							onSelected: u[4] ||= (e) => v(M)({ houseNumberSuffix: e.value }, d.parentPath)
						}, null, 8, [
							"label",
							"name",
							"placeholder",
							"suggestions"
						])
					]),
					_: 2
				}, [v(N)?.content?.[v(h)]?.faq?.postalCode ? {
					name: "note",
					fn: x(() => [c(v(se), { keypath: "location.fields.postalCodeAndNumber.note.description" }, {
						link: x(() => [c(v(ne), {
							href: v(N).content[v(h)].faq.postalCode,
							target: v(oe).Blank
						}, {
							default: x(() => [s(_(v(m)("location.fields.postalCodeAndNumber.note.link.label")), 1)]),
							_: 1
						}, 8, ["href", "target"])]),
						_: 1
					})]),
					key: "0"
				} : void 0]), 1032, ["label"]),
				c(v(T), {
					label: v(m)("location.address.street"),
					name: v(q)("address.street", l.parentPath),
					placeholder: v(m)("location.address.street")
				}, null, 8, [
					"label",
					"name",
					"placeholder"
				]),
				c(v(T), {
					label: v(m)("location.address.streetAdditionalInfo"),
					name: v(q)("address.additionalInformation", l.parentPath),
					placeholder: v(m)("location.address.streetAdditionalInfo"),
					sublabel: v(m)("optional")
				}, null, 8, [
					"label",
					"name",
					"placeholder",
					"sublabel"
				])
			], 64)) : (p(), i(e, { key: 5 }, [
				c(v(T), {
					label: v(m)(xe.value),
					name: v(q)("address.street", l.parentPath),
					placeholder: v(m)("location.address.street")
				}, null, 8, [
					"label",
					"name",
					"placeholder"
				]),
				c(v(S), { label: v(m)("location.fields.houseNumberAndAddition.label") }, {
					default: x(() => [c(v(T), {
						class: "grow",
						"hide-label": "",
						label: v(m)("location.address.houseNumber"),
						name: L.value,
						placeholder: v(m)("location.address.houseNumber"),
						"preserve-label-gap": !1
					}, null, 8, [
						"label",
						"name",
						"placeholder"
					]), X.value ? (p(), n(v(T), {
						key: 0,
						class: "grow",
						"hide-label": "",
						label: v(m)("location.address.boxNumber"),
						name: v(q)("address.boxNumber", l.parentPath),
						placeholder: v(m)("location.address.boxNumber"),
						"preserve-label-gap": !1
					}, null, 8, [
						"label",
						"name",
						"placeholder"
					])) : (p(), n(v(T), {
						key: 1,
						class: "grow",
						"hide-label": "",
						label: v(m)("location.address.houseNumberExtension"),
						name: v(q)("address.houseNumberSuffix", l.parentPath),
						placeholder: v(m)("location.address.houseNumberExtension"),
						"preserve-label-gap": !1
					}, null, 8, [
						"label",
						"name",
						"placeholder"
					]))]),
					_: 1
				}, 8, ["label"]),
				c(v(T), {
					label: v(m)("location.address.streetAdditionalInfo"),
					name: v(q)("address.additionalInformation", l.parentPath),
					placeholder: v(m)("location.address.streetAdditionalInfo"),
					sublabel: v(m)("optional")
				}, null, 8, [
					"label",
					"name",
					"placeholder",
					"sublabel"
				]),
				c(v(T), {
					label: v(m)("location.address.postalCode"),
					name: I.value,
					placeholder: v(m)("location.address.postalCode"),
					sublabel: v(ee)(v(z)) ? v(m)("optional") : void 0
				}, null, 8, [
					"label",
					"name",
					"placeholder",
					"sublabel"
				])
			], 64)),
			c(v(T), {
				label: v(m)("location.address.city"),
				name: v(q)("address.city", l.parentPath),
				placeholder: v(m)("location.address.city")
			}, null, 8, [
				"label",
				"name",
				"placeholder"
			]),
			!J.value && !Y.value ? (p(), n(v(T), {
				key: 6,
				label: v(m)("location.address.region"),
				name: v(q)("address.region", l.parentPath),
				placeholder: v(m)("location.address.region"),
				sublabel: v(m)("optional")
			}, null, 8, [
				"label",
				"name",
				"placeholder",
				"sublabel"
			])) : r("", !0)
		]));
	}
}), Pe = Object.keys(D), $ = H.extend({
	houseNumberSuffix: E.schema.handleEmptyAndNullAsUndefined(H.shape.houseNumberSuffix).optional(),
	additionalInformation: E.schema.handleEmptyAndNullAsUndefined(H.shape.additionalInformation).optional(),
	boxNumber: E.schema.handleEmptyAndNullAsUndefined(H.shape.boxNumber).optional(),
	region: E.schema.handleEmptyAndNullAsUndefined(H.shape.region).optional(),
	state: E.schema.handleEmptyAndNullAsUndefined(H.shape.state).optional()
}), Fe = $.extend({
	countryCode: U.literal(D.NL),
	postalCode: $.shape.postalCode.unwrap().refine((e) => e && O(e, D.NL)),
	houseNumber: $.shape.houseNumber.unwrap(),
	region: E.schema.handleEmptyAsUndefined($.shape.region).optional()
}), Ie = (e) => $.extend({ countryCode: U.literal(e) }), Le = (e) => e.extend({ postalCode: E.schema.handleEmptyAsUndefined($.shape.postalCode) }), Re = (e, t) => e.extend({ postalCode: $.shape.postalCode.unwrap().refine((e) => e && O(e, t)) }), ze = (e) => e.extend({ region: E.schema.handleEmptyAsUndefined($.shape.region).optional() }), Be = (e) => e.extend({ houseNumber: E.schema.handleEmptyAndNullAsUndefined($.shape.houseNumber) }), Ve = U.discriminatedUnion("countryCode", Pe.reduce((e, t) => {
	if (t === D.NL) return e.push(Fe), e;
	let n = Be(ze(Ie(t)));
	return ee(t) ? e.push(Le(n)) : e.push(Re(n, t)), e;
}, [])), He = le.superRefine((e, t) => {
	e.phoneNumber && !z.phone.test(e.phoneNumber) && t.addIssue({
		code: "custom",
		path: ["phoneNumber"],
		message: "validation.invalidPhone"
	});
}), Ue = ue.superRefine((e, t) => {
	e.phoneNumber && !z.phone.test(e.phoneNumber) && t.addIssue({
		code: "custom",
		path: ["phoneNumber"],
		message: "validation.invalidPhone"
	});
}), We = U.discriminatedUnion("type", [He, Ue]), Ge = We, Ke = Ve, qe = Ke.options.map((e) => e.extend({ region: E.schema.handleEmptyAsUndefined(U.string().optional()) })), Je = U.discriminatedUnion("countryCode", qe), Ye = de({
	address: Ke,
	contact: Ge
}), Xe = (e) => e ? e.toUpperCase() === j.Row || e.toUpperCase() === j.World || e.toUpperCase() === j.Cd : !1, Ze = (e) => e ? e.toUpperCase() === j.Eu : !1;
//#endregion
export { Ve as AddressSchema, fe as BusinessContactField, He as ContactBusinessSchema, Ue as ContactPrivateSchema, We as ContactSchema, pe as PrivateContactField, Ne as ShippingAddress, Je as addressSchemaWithOptionalRegion, Ke as basicAddressSchema, Ge as contactSchema, q as getFullFieldName, _e as isBelgium, Ze as isEuShipment, ge as isNetherlands, Xe as isRowShipment, Ye as shippingAddressSchema, K as useAddress, me as useAutofill, he as useContact, W as useValidate };
